import api from './api';

export const getNotificationPreferences = () =>
  api.get('/notifications/preferences');

export const updateNotificationPreferences = (preferences) =>
  api.post('/notifications/preferences', preferences);

export const sendTestEmailNotification = () =>
  api.post('/notifications/email/test');

export const sendTestTelegramNotification = () =>
  api.post('/notifications/telegram/test');
